module.exports = __webpack_public_path__ + "static/media/maternity9.279e6b10.jpg";